import React from 'react';
import Icon, {ICONS} from '../Icon';

const PropertyItem = ({nodeId, propertyId, type, value, readable, writable}) => (
    <div className="property-item">
        <h2><Icon icon={ICONS.PROPERTY} /> {propertyId} <small><code>{type}</code> {readable && 'R'}{writable && 'W'}</small></h2>
        <pre>{JSON.stringify(value)}</pre>
    </div>
);

export default PropertyItem;
